export default __webpack_public_path__ + "static/media/584.2bc6510f.gif";